import {
  ATypeMainHead,
  ATypeCardView,
  FUNERAL_SIDO,
  BTypeBreadCrumb,
  FUNERAL_SIGUNGU,
  ATypeBeneficiaryCTA,
  colors,
  ATypeMap,
  FullWidthButton,
} from "goi_common";
import { GetStaticPaths, GetStaticProps } from "next";

import React from "react";
import { ParlorDetailProps } from "goi_common";
import { parlorRegion } from "@/constants/parlorRegion";
import { Box, Stack } from "@mui/material";
import Head from "next/head";
import facilities from "goi_common/src/constants/facilities_detail.json";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = facilities
    .filter((f) => targetSidos.includes(f.sido) && f.is_public)
    .map((f) => ({
      params: {
        companyname: f.companyname,
      },
    }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const companyname = params?.companyname;
  let p_facility;
  let district;
  let name = "";
  let description = "";

  if (companyname) {
    p_facility = facilities.find((f) => f.companyname === companyname);
    if (p_facility) {
      name = p_facility.companyname;

      district = p_facility.address.slice(0, 2);
      if (p_facility.address.split(" ")[0].length == 4)
        district = p_facility.address[0] + p_facility.address[2];

      description = `기초생활수급자 공설 장지 혜택 비용 정리 및 안내. 혜택 적용 가능한 화장장 필요 서류, 상담. 기초생활수급자(의료, 생계)라면 위의 2가지 혜택을 받을 수 있습니다. 만약 이해하기 어려운 점이 있거나 더 자세하게 알고 싶은 것이 있다면, 바로 상담을 진행하세요.`;
    }
  }

  return {
    props: {
      defaultPFacility: p_facility,
      pageDescription: description,
      pageKeywords: `${p_facility?.companyname}, ${p_facility?.companyname} 기초생활수급자, ${district} 기초생활수급자 장례, 장제비, 장제급여, 기초생활수급자 장례 얼마,`,
      pageOgTitle: `${p_facility?.companyname} 기초생활수급자 헤택 비용 안내 | 대구경북장례정보포털`,
      pageOgDescription: description,
      pageOgImage: p_facility?.images[0].url || "",
      hasError: !p_facility,
    },
  };
};

export default function companyname({
  defaultPFacility,
  pageOgTitle,
}: {
  defaultPFacility: ParlorDetailProps;
  pageOgTitle: string;
}) {
  const regionPFacilities = facilities.filter((p) =>
    targetSidos.includes(String(p.sido)) && p.is_public
  );

  const carouselItems = regionPFacilities.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://dggb-portal.funeralblog.co.kr/beneficiary/public-facility/${res.companyname}/`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionPFacilities.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};
  return (
    <Stack>
      <Head>
        <title>{pageOgTitle}</title>
        {regionPFacilities.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>

      <BTypeBreadCrumb
        firstItem={{
          text: `대구 경북 기초생활수급자 장례헬프센터`,
          href: `/beneficiary/`,
          event: {
            domain: "dggb",
            path: "benef_facility",
            trigger_and_target: "br_crumb_benef",
          },
        }}
        goiHomeEvent={{
          domain: "dggb",
          path: "benef_facility",
          trigger_and_target: "br_crumb_goi_home",
        }}
      />
      <ATypeMainHead
        defaultParlor={defaultPFacility}
        title={`${defaultPFacility.companyname}`}
        managed_type={defaultPFacility.managed_type}
        address={defaultPFacility.address}
      />

      <Stack
        className="body_16_m"
        style={{
          background: colors.gray50,
          padding: "12px 14px",
          margin: "0 20px",
        }}
      >
        기초생활수급자는 화장 비용이 전액 감면됩니다.
      </Stack>

      <Stack padding="18px 20px 40px" gap="40px">
        <Box className="body_14_m">
          e-하늘장사정보시스템에서 가져온 정보이며, 자세한 안치 대상 여부를
          알아보려면 상담이 필요합니다.
        </Box>
        <FullWidthButton
          text="바로 상담하기"
          href="tel:1666-9784"
          backgroundColor={colors.orange650}
          event={{
            domain: "dggb",
            path: "benef_pub_facility",
            trigger_and_target: "goi_call",
          }}
        />
      </Stack>

      <Stack
        style={{ background: regionColor.c100 }}
        padding="40px 20px"
        marginBottom="40px"
        gap="8px"
      >
        <ATypeMap defaultParlor={defaultPFacility} />
      </Stack>
      <Stack padding="0px 20px" marginBottom="40px" gap="8px">
        <h3 className="button_16_sb">대구 · 경북 지역 장지</h3>
        {regionPFacilities.map((res) => (
          <ATypeCardView
            key={res.companyname}
            name={res.companyname}
            href={`/beneficiary/public-facility/${res.companyname}/`}
            // descriptions={["기초생활수급자 무료"]}
            descriptions={[""]}
            imgSrc={res.images[0]?.url ? res.images[0].url : ""}
            event={{
              domain: "dggb",
              path: "benef_pub_facility",
              trigger_and_target: "uv_facility_detail",
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
}
